export default "__VITE_PUBLIC_ASSET__2c3c52e5__"